import { z } from "zod";
import {
  App,
  routes as allRoutes,
  fullEndpoints,
} from "@songtradr-sso/shared/common";
import {
  emailSchema,
  firstNameSchema,
  lastNameSchema,
  newPasswordSchema,
  staticText as sharedText,
} from "@songtradr-sso/shared/frontend";
import { staticText } from "../../../shared/statics/static-text";
import { Api } from "../../../shared/utils/api.utils";

// TEXT
export const text = {
  ...staticText.emailSignUp,
  shared: { inputs: sharedText.inputs },
};

// STYLES

// DATA
export const emailPasswordSignUp = (signUpRequest: string) => {
  return Api.request({
    method: "POST",
    url: endpoints.emailPasswordSignUp,
    data: {
      signUpRequest,
    },
  });
};

// TYPES
export type FormFields = z.infer<typeof schema>;

// CONSTANTS
export const routes = allRoutes[App.Core];
const endpoints = fullEndpoints[App.Core].auth;

export const schema = z
  .object({
    given_name: firstNameSchema,
    family_name: lastNameSchema,
    email: emailSchema,
    newPassword: newPasswordSchema,
    confirmPassword: z
      .string()
      .min(1, text.shared.inputs.password.confirmPassword.validation.required),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: text.shared.inputs.password.newPassword.validation.rules.match,
    path: [text.shared.inputs.password.confirmPassword.id], // Set the error on confirmPassword field
  });

// FUNCTIONS

// ASSETS
